import { TranslateCompiler } from '@ngx-translate/core';
import { environment } from '@environments/environment';

export class BrandTranslateCompiler extends TranslateCompiler {

  private readonly brandName: string = (environment as any).brandName || 'Calenso';
  private readonly brandUrls: Record<string, string> = (environment as any).brandUrls || {};
  private readonly urlPattern = /(https?:\/\/[^\s<>"']+|mailto:[^\s<>"']+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
  private readonly isCalenso = this.brandName === 'Calenso';

  compile(value: string): string {
    if (typeof value !== 'string') {
      return value;
    }
    return this.isCalenso ? this.replaceUrlPlaceholders(value) : this.replaceBrand(value);
  }

  compileTranslations(translations: any): any {
    return this.processObject(translations);
  }

  private processObject(obj: any): any {
    if (typeof obj === 'string') {
      return this.isCalenso ? this.replaceUrlPlaceholders(obj) : this.replaceBrand(obj);
    }
    if (Array.isArray(obj)) {
      return obj.map(item => this.processObject(item));
    }
    if (obj !== null && typeof obj === 'object') {
      const result: any = {};
      for (const key of Object.keys(obj)) {
        result[key] = this.processObject(obj[key]);
      }
      return result;
    }
    return obj;
  }

  private replaceUrlPlaceholders(value: string): string {
    return value.replace(/%([A-Z_]+)%/g, (match, key) => this.brandUrls[key] || match);
  }

  private replaceBrand(value: string): string {
    const placeholders: string[] = [];

    const preserved = value.replace(this.urlPattern, (url) => {
      placeholders.push(url);
      return `__URL_PLACEHOLDER_${placeholders.length - 1}__`;
    });

    const replaced = preserved.replace(/calenso/gi, (match) => {
      if (match === 'CALENSO') return this.brandName.toUpperCase();
      if (match === 'calenso') return this.brandName.toLowerCase();
      return this.brandName;
    });

    const restored = replaced.replace(/__URL_PLACEHOLDER_(\d+)__/g, (_, index) => placeholders[+index]);
    return this.replaceUrlPlaceholders(restored);
  }
}
